import { createAsyncThunk } from '@/redux/createAsyncThunk';
import TEST_HOUSES from '@/utils/testHouses';

import { fetchBidHistoryIfNeeded } from '../bidHistory';
import { fetchCatalogsIfNeeded } from '../catalog/catalogs/catalog.actions';
import { fetchCatalogDetailsIfNeeded } from '../catalog/detail/catalogDetail.actions';
import { fetchCatalogItemSummaries } from '../catalog/items/catalogItems.actions';
import { loadRelatedGeoAreaByLocation } from '../geoArea/geoArea';
import {
    getItemSummaryCatalogId,
    getItemSummaryIndex,
    getItemSummarySellerId,
} from '../item/summary/itemSummary.selectors';
import { getItemDetailAgentId } from '../itemDetail';
import { fetchListingAgentsIfNeeded } from '../listingAgent';
import { fetchSellersDetailsIfNeeded } from '../sellerDetail';
import { fetchSellerFollowerCountIfNeeded } from '../sellerFollowerCount';
import { fetchSellerRatingSummaryByIdIfNeeded } from '../sellerRatings';

export const fetchDataForEndedItemPage = createAsyncThunk<
    Promise<unknown>,
    {
        itemId: number;
    }
>('la/domain/itemPage/fetchDataForEndedItemPage', async ({ itemId }, { dispatch, getState }) => {
    const state = getState();
    const catalogId = getItemSummaryCatalogId(state, itemId);
    const sellerId = getItemSummarySellerId(state, itemId);
    const index = getItemSummaryIndex(state, itemId);
    const agentId = getItemDetailAgentId(state, itemId);

    // we need to load the previous item plus the next 2 items for the item page
    const startingIndexForCatalogCarousel = index === 0 ? 0 : index - 1;

    const query: any = {
        index: startingIndexForCatalogCarousel,
        pageSize: 4,
    };
    if (TEST_HOUSES.includes(sellerId)) {
        query.preview = true;
    }

    const promises: Promise<unknown>[] = [
        dispatch(fetchBidHistoryIfNeeded(itemId)),
        dispatch(fetchCatalogDetailsIfNeeded([catalogId])),
        dispatch(fetchCatalogItemSummaries({ catalogId, query })),
        dispatch(fetchCatalogsIfNeeded({ catalogIds: [catalogId] })),
        dispatch(fetchListingAgentsIfNeeded([agentId])),
        dispatch(fetchSellerFollowerCountIfNeeded([sellerId])),
        dispatch(fetchSellerRatingSummaryByIdIfNeeded(sellerId)),
        dispatch(fetchSellersDetailsIfNeeded([sellerId])),
        dispatch(loadRelatedGeoAreaByLocation(catalogId)),
    ];

    return Promise.all(promises);
});
